module.exports = __webpack_public_path__ + "static/media/sleep-and-relaxation-large@3x.8cc9173e.png";